export const SITE_CONFIG = {
  name: "CIRCLE Natural Editing",
  legalName: "El Círculo Landscape ARQ",
  url: "https://circlenaturaledit.com",
  phone: "524448050926",
  phoneFormatted: "+52 444 805 0926",
  email: "tropicaldesertarq@proton.me",
  whatsapp: {
    number: "524448050926",
    defaultMessage: "Hola, me interesa saber más sobre sus servicios de paisajismo.",
    appointmentMessage: "Hola, me interesa agendar una visita inicial para mi propiedad.",
  },
  social: {
    instagram: "https://www.instagram.com/circle.naturaledit",
    facebook: "https://www.facebook.com/circlenaturaledit",
  },
  location: {
    city: "San José del Cabo",
    state: "BCS",
    country: "México",
    full: "San José del Cabo, BCS, México",
  },
};
